import React, { useContext } from 'react'
import { Controller, useFieldArray, useFormContext } from 'react-hook-form'
import { ClimaOptionsContext } from '../..'
import { Card, CardContent, Checkbox, Form } from 'semantic-ui-react'
import { FormFields } from '~/components/FormFields'

const PlantSelection:React.FC = () => {
  const { control, setValue, clearErrors } = useFormContext()
  const { plantProtections } = useContext(ClimaOptionsContext)

  const { fields, append, remove } = useFieldArray({
    control,
    name: 'maizeSilage.plantProtections',
    keyName: 'key'
  })

  function renderPlantData(index) {
    return <>
      <FormFields.Input
        control={control}
        noErrorMessage
        name={`maizeSilage.plantProtections[${index}].number`}
        placeholder={'Anzahl Behandlung(en)'}
        onChange={(event) => {
          setValue(`maizeSilage.plantProtections[${index}].number`, event?.target?.value)
          clearErrors(`maizeSilage.plantProtections[${index}].number`)
        }}
        typeInput='controled'
        suffix=' Behandlung(en)'
        label={'Anzahl'}
      />
      <FormFields.Input
        control={control}
        noErrorMessage
        onChange={(event) => {
          setValue(`maizeSilage.plantProtections[${index}].waterUsed`, event?.target?.value)
          clearErrors(`maizeSilage.plantProtections[${index}].waterUsed`)
        }}
        name={`maizeSilage.plantProtections[${index}].waterUsed`}
        placeholder={'in l/ha'}
        typeInput='controled'
        label={'Ausbringmenge Wasser'}
        suffix=' l/ha'
      />
    </>
  }

  return <>
    <Controller
      name='maizeSilage.plantProtections'
      render={({ fieldState: { error } }) => (
        <Form.Field error={Boolean(error)}>
          <label>{'Wählen Sie bzgl. Pflanzenschutz die jeweilige Behandlungsmaßnahme sowie die Anzahl der Anwendungen und die Ausbringmenge an Wasser.'}</label>
          <div style={{ display: 'flex', gap: 20 }}>
            {plantProtections?.map((plantSelection, index) => {
              return <Checkbox
                key={plantSelection.id}
                label={plantSelection.label}
                checked={Boolean(fields.find(field => field['id'] === plantSelection.id))}
                onChange={(_, data) => {
                  if(data.checked) {
                    append({ ...plantSelection, waterUsed: '', number: '' })
                    return
                  }
                  remove(index)
                }}
              />
            })}
          </div>
        </Form.Field>
      )}
    />
    <div style={{ display: 'flex', alignItems: 'baseline', gap: 20, flexWrap: 'wrap', marginBottom: '2em' }}>
      {fields.map((plantSelection, index) => {
        return <Card key={plantSelection['id']}>
          <CardContent header={plantSelection['label']} />
          <CardContent description={renderPlantData(index)} />
        </Card>
      })}
    </div>
  </>
}
export default PlantSelection